"use client"

import { ComponentConfig } from "@measured/puck"
import { RenderConfig, WeeklyLeafletRenderProps } from "./RenderConfig"

export const WeeklyLeaflet: ComponentConfig<WeeklyLeafletRenderProps> = {
  label: "Tamda Foods | Weekly Leaflet",
  fields: {
    title: {
      label: "Title",
      type: "text",
    },
    isDisplayLink: {
      label: "Is Display Link",
      type: "radio",
      options: [
        { label: "Yes", value: true },
        { label: "No", value: false },
      ],
    },
    viewAllUrl: {
      label: "View All URL",
      type: "text",
    },
    className: {
      label: "Class Name",
      type: "text",
    },
  },
  defaultProps: {
    title: "LETÁK TUẦN",
    className: "",
    viewAllUrl: "/",
  },
  ...RenderConfig,
}
